
export const chineseNumbers = [
    "一",
];

export const closePage = () => {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        WeixinJSBridge.call("closeWindow");
    } else {
        window.close();
    }
}


export const playLotterySound = (name) => {
      // 播放一个极短的静音来解锁音频引擎
      let clickAudio = document.getElementById(name);
      clickAudio.volume = 0;
      clickAudio.play();
      clickAudio.volume = 1;
}



// WEBPACK FOOTER //
// ./src/utils/tool.js